import { ArrowBack, ElectricBolt } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ErrorPage() {
  const { t } = useTranslation();
  return (
    <Stack
      height="100vh"
      width={1}
      direction="column"
      gap={2}
      justifyContent="center"
      alignItems="center"
    >
      <Stack direction="row" gap={2}>
        <ElectricBolt sx={{ fontSize: "70px", color: "gray" }} />
        <Typography variant="h2" fontWeight="bold" color="gray">
          {t("notfound")}
        </Typography>
      </Stack>
      <Button
        component={Link}
        to="/"
        variant="contained"
        startIcon={<ArrowBack />}
        color="inherit"
      >
        {t("back")}
      </Button>
    </Stack>
  );
}
